import { Box, Typography, Button, Grid } from '@mui/material';
import { UploadCloud } from 'lucide-react';

export function DocumentsStep({ formik }) {
  // Mock file upload handler
  const handleFileUpload = (field) => (e) => {
    const file = e.target.files[0];
    if (file) {
      formik.setFieldValue(field, file.name); // Just storing name for mock purposes
    }
  };

  const renderUploadBox = (title, field, accept) => (
    <Box
      sx={{
        border: '1px dashed',
        borderColor: 'divider',
        borderRadius: 2,
        p: 3,
        textAlign: 'center',
        bgcolor: 'background.default',
      }}
    >
      <UploadCloud size={32} color="#9e9e9e" />
      <Typography variant="subtitle2" sx={{ mt: 1, mb: 2 }}>
        {title}
      </Typography>
      
      {formik.values[field] ? (
        <Typography variant="body2" color="primary.main" gutterBottom>
          Selected: {formik.values[field]}
        </Typography>
      ) : (
        <Typography variant="body2" color="text.secondary" gutterBottom>
          No file selected
        </Typography>
      )}

      <Button variant="outlined" component="label" size="small" fullWidth>
        Browse Files
        <input
          type="file"
          hidden
          accept={accept}
          onChange={handleFileUpload(field)}
        />
      </Button>
    </Box>
  );

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 3 }}>
          {renderUploadBox('Profile Photo', 'photo', 'image/*')}
        </Grid>
        <Grid size={{ xs: 12, md: 3 }}>
          {renderUploadBox('Resume / CV', 'resume', '.pdf,.doc,.docx')}
        </Grid>
        <Grid size={{ xs: 12, md: 3 }}>
          {renderUploadBox('Degree Certificates', 'certificates', '.pdf,image/*')}
        </Grid>
        <Grid size={{ xs: 12, md: 3 }}>
          {renderUploadBox('Aadhaar / PAN Copy', 'idProof', '.pdf,image/*')}
        </Grid>
      </Grid>
    </Box>
  );
}
